import React from "react";
import DataBox from "./DataBox";
import Example from "./rechartcomp";

export default class GraphPair extends React.Component{

    render(){
        
        const box_data = this.props.box_data
        const graph_data = this.props.graph_data

        return(
            <div className="graphpair">
                <Example data={graph_data} />
                <DataBox data={box_data} />
            </div>
        )
    }

}
